import { Badge } from '@/shared/ui/badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/shared/ui/dialog';
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from '@/shared/ui/table';
import { fmtDate } from '@/features/pilotage/components/AssetPilotageRow';

/**
 * Journal des actions de pilotage.
 *
 * Lu par un humain : il porte le geste tel qu'il a été cliqué, le nom de son auteur et
 * le client concerné. Une action simulée y est signalée — sinon le journal laisserait
 * croire que le parc a réellement bougé.
 */
export default function PilotageJournal({ open, onOpenChange, entries }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-3xl max-h-[80vh] overflow-hidden flex flex-col"
        data-testid="journal-dialog"
      >
        <DialogHeader><DialogTitle>Journal des actions de pilotage</DialogTitle></DialogHeader>
        <div className="overflow-y-auto flex-1">
          {entries.length === 0 ? (
            <p className="text-sm text-neutral-400 text-center py-6">Aucune action enregistrée</p>
          ) : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead className="w-[130px]">Date</TableHead>
                  <TableHead>Utilisateur</TableHead>
                  <TableHead>Actif</TableHead>
                  <TableHead>Action</TableHead>
                  <TableHead>Résultat</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {entries.map(e => (
                  <TableRow key={e.id} data-testid={`journal-row-${e.id}`}>
                    <TableCell className="text-[11px] text-neutral-500 whitespace-nowrap">
                      {fmtDate(e.created_at)}
                    </TableCell>
                    <TableCell className="text-[12px]">{e.user_nom || '—'}</TableCell>
                    <TableCell className="text-[12px]">
                      <span className="text-neutral-700">{e.client_nom || '—'}</span>
                      <span className="text-neutral-400 text-[10px] ml-1">{e.asset_type}</span>
                    </TableCell>
                    <TableCell className="text-[12px] text-neutral-700">
                      {e.action}
                      {e.value_w != null && (
                        <span className="text-neutral-400"> · {e.value_w} W</span>
                      )}
                      {e.simulated && (
                        <span className="ml-1 px-1 rounded bg-neutral-200 text-neutral-600 text-[9px] uppercase">
                          simulé
                        </span>
                      )}
                    </TableCell>
                    <TableCell>
                      <Badge
                        variant="outline"
                        className={e.success
                          ? 'bg-emerald-50 text-emerald-700 border-emerald-200 text-[10px]'
                          : 'bg-red-50 text-red-700 border-red-200 text-[10px]'}
                      >
                        {e.success ? 'succès' : 'échec'}
                      </Badge>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
